module.exports = __webpack_public_path__ + "img/116.98495555.png";